import React, { useEffect } from 'react';
import { produce } from 'immer';
import { useLocation } from "@remix-run/react";
import { jsx as _jsx } from "react/jsx-runtime";
export const initialState = {
  log: []
};
const DebugContext = /*#__PURE__*/React.createContext(undefined);
const DebugDispatchContext = /*#__PURE__*/React.createContext(undefined);
export const reducer = (state, action) => produce(state, draft => {
  switch (action.type) {
    case 'log-page':
      {
        const lastPage = draft.log[draft.log.length - 1];
        if (!lastPage || lastPage.url !== action.page.url) {
          draft.log.push(action.page);
        }
        return draft;
      }
    case 'log-il-request':
      {
        addInitialLogEntry(draft);
        const pageLog = draft.log[draft.log.length - 1];
        pageLog.requests.push(action.requests);
        return draft;
      }
    case 'log-failed-il-request':
      {
        addInitialLogEntry(draft);
        const pageLog = draft.log[draft.log.length - 1];
        pageLog.failedRequests.push(action.requests);
        return draft;
      }
    default:
      {
        throw new Error(`Unhandled action type: ${action.type}`);
      }
  }
});
const addInitialLogEntry = state => {
  if (state.log.length === 0) {
    state.log.push(createPageLogEntry());
  }
};
const createPageLogEntry = (url = 'initial') => ({
  url,
  timestamp: new Date().toISOString(),
  requests: [],
  failedRequests: []
});
export const DebugProvider = ({
  children
}) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  const location = useLocation();
  useEffect(() => {
    dispatch({
      type: 'log-page',
      page: createPageLogEntry(location.pathname)
    });
  }, [location.pathname]);
  useEffect(() => {
    const ssrData = window.__PLAY_DEBUG__;
    const ilRequests = ssrData?.ilRequests || [];
    const failedIlRequests = ssrData?.failedIlRequests || [];
    if (ilRequests.length > 0 || failedIlRequests.length > 0) {
      dispatch({
        type: 'log-il-request',
        requests: {
          method: 'SSR',
          url: '',
          timestamp: new Date().toISOString(),
          responseTime: '',
          ilRequests,
          failedIlRequests
        }
      });
    }
  }, []);
  return /*#__PURE__*/_jsx(DebugContext.Provider, {
    value: state,
    children: /*#__PURE__*/_jsx(DebugDispatchContext.Provider, {
      value: dispatch,
      children: children
    })
  });
};
export const useDebugState = () => {
  const context = React.useContext(DebugContext);
  if (context === undefined) {
    throw new Error('useDebugState must be used within a DebugProvider');
  }
  return context;
};
export const useDebugDispatch = () => {
  const context = React.useContext(DebugDispatchContext);
  if (context === undefined) {
    throw new Error('useDebugDispatch must be used within a DebugProvider');
  }
  return context;
};